import type {
  ActivityLookupByType,
  SubEntryType,
  DeepPartial,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import type { EditableSubEntry } from "src/types"

/*
 * returns a function that allows partially updating an activity
 */
export function useUpdateActivity<T extends SubEntryType>(
  activityType: T,
  currentActivity: DeepPartial<ActivityLookupByType<T>> | undefined,
  updateSubEntry: (s: Partial<EditableSubEntry<T>>) => void,
) {
  return useCallback(
    (activity: DeepPartial<ActivityLookupByType<T>>) => {
      if (typeof activity === "object" && typeof currentActivity === "object") {
        updateSubEntry({
          [activityType]: {
            ...currentActivity,
            ...activity,
          },
        })
      } else {
        updateSubEntry({
          [activityType]: activity,
        })
      }
    },
    [
      activityType,
      currentActivity,
      updateSubEntry,
    ],
  )
}
